import {VECTOR3} from '../../index.js';

/**
 * Creates Hypercube.js ambiant lights.
 * @example
 * const lightambiant = new LightAmbiant(name, color);
 */
class LightAmbiant {

    /**
     * Stores the color.
     * @type {vector3}
     * @protected
     */
    $color;

    /**
     * Stores the name.
     * @type {string}
     * @private
     */
    $name;

    /**
     * Stores the type.
     * @type {string}
     * @protected
     */
    $type = 'light.ambiant';

    /**
     * Gets the color.
     * @type {vector3}
     * @public
     * @readonly
     */
    get color() {

        return this.$color;
    };

    /**
     * Gets the name.
     * @type {string}
     * @public
     * @readonly
     */
    get name() {

        return this.$name;
    }

    /**
     * Creates a new Hypercube.js ambiant light.
     * @param {string} $name The name of the light.
     * @param {vector3} $color The color of the light.
     */
    constructor($name, $color) {

        this.$name = $name;
        this.$color = VECTOR3.clone($color);
    }
}

export {

    LightAmbiant
};

export default LightAmbiant;
